<template>
  <Notice
    v-if="isShowNotice"
    :is-show-notice="isShowNotice"
    :text="noticeInfo.noticeText"
    :link-text="noticeInfo.linkText"
    :link="noticeInfo.linkToUrl"
    @closeNotice="closeNotice"
    @onLinkClick="onLinkClick"
  />
</template>
<script>
import Notice from 'src/local-component/ui/tip-match/tip-match-global-notice';
import { cookie } from '@tencent/pmd-tools/lib/storage';
import md5 from 'md5';
import { getFrontConfig } from 'src/local-logic/tip-match/front-config/index.js';


function getKeysObj(obj, keys) {
  const outObj = {};
  keys.forEach((key) => {
    outObj[key] = obj[key];
  });
  return outObj;
}
export default {
  components: {
    Notice,
  },
  options: {
    virtualHost: true,
  },
  data() {
    return {
      isShowNotice: false,
      noticeInfo: {
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.getGlobaleNoticeInfo();
    }, 500);
    uni.$on(this.g_pageid_lifecycle('onShow'), this.getGlobaleNoticeInfo);
  },
  methods: {
    getGlobaleNoticeInfo() {
      getFrontConfig('saibao_global_announcement', 'saibao_global_announce_test').then((noticeInfo) => {
        if (!(noticeInfo?.noticeText)) return noticeInfo;
        const { showNoticePageNameList = [] } = noticeInfo;
        const cookieIsHide = cookie.get('smoba_show_global_notice') === md5(noticeInfo.noticeText || '') || false;
        this.isShowNotice = !cookieIsHide ? showNoticePageNameList.includes(app.$router.currentRoute.name)
          : false;
        this.noticeInfo = getKeysObj(noticeInfo, ['noticeText', 'linkText', 'linkToUrl']);
        if (this.isShowNotice) {
          this.reportPageExposure('match_global', 'all', { eventId: 'esports_global_notify_show' });
        }
        return noticeInfo;
      });
    },
    onLinkClick() {
      this.reportClick('match_global', 'esports_global_notify_detail_click');
      if (!this.noticeInfo.linkToUrl) return;
      if (this.noticeInfo.linkToUrl.indexOf('http') > -1) {
        // #ifdef H5
        window.location.href = this.noticeInfo.linkToUrl;
        // #endif
      } else {
        uni.navigateTo({ url: this.noticeInfo.linkToUrl });
      }
    },
    closeNotice() {
      this.isShowNotice = false;
      cookie.set('smoba_show_global_notice', md5(this.noticeInfo.noticeText));
    },
  },
};

</script>
